import React, {useState} from 'react';
import './ordermodel.css';

const OrderModal = ({ investedDict, sessionTime, onPlaceOrder, onCancelOrder }) => {
    const [isPlaceOrderDisabled, setIsPlaceOrderDisabled] = useState(false);

    const totalAmount = Object.values(investedDict).reduce((acc, value) => acc + value, 0);
    const totalOrders = Object.keys(investedDict).length;

    const handlePlaceOrder = () => {
        setIsPlaceOrderDisabled(true); // Disable the button
        onPlaceOrder(); // Call the parent-provided function
    };
    return (
        <div className="main-containerorder ">
        <div className="popup-overlayorder">
            <div className='popup-containerorder tableorder'>
                <h3 style={{fontWeight:"bolder"}}>Order Details</h3>
                <h4>Order Time : {sessionTime}</h4>
                <table>
                    <thead>
                        <tr>
                            <th>Order Number</th>
                            <th>Order Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(investedDict).map(([orderNumber, orderAmount]) => (
                            <tr key={orderNumber}>
                                <td>{orderNumber}</td>
                                <td>{orderAmount}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>Total Orders: {totalOrders}</td>
                            <td>Total Amount: RS. {totalAmount}</td>
                        </tr>
                    </tfoot>
                </table>

                <div>
                    <button  onClick={handlePlaceOrder} disabled={isPlaceOrderDisabled}>Place Order</button>
                    <button onClick={onCancelOrder}>Cancel Order</button>
                </div>
            </div>
        </div>
    </div>
    );
};

export default OrderModal;
